import { BTable, BFormGroup, BFormInput, BFormCheckbox } from "bootstrap-vue";
import Loading from "@@/core/components/shared/Loading/Loading";
import ImageHolder from "@@/core/components/shared/ImageHolder/ImageHolder";

export default {
  name: "SellerDetail",
  components: {
    Loading,
    ImageHolder,
    BTable,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
  },
  data() {
    return {
      seller: null,
      sellerRequests: null,
      id: this.$route.params.id,
      page: 1,
      previousPage: 1,
      per_page: 40,
      productSku: "",
      disabled: true,
      filterBtns: [
        {
          title: "همه",
          id: 1,
          status: "all",
          active: true,
          style: "badge badge-success status border-none",
        },
        {
          title: "جدید",
          id: 2,
          status: "pending",
          active: false,
          style: "badge badge-warning status border-none",
        },
        {
          title: "ارسال شده",
          id: 3,
          status: "sent",
          active: false,
          style: "badge badge-secondary status border-none",
        },
        {
          title: "فروخته شده",
          id: 4,
          status: "sold",
          active: false,
          style: "badge badge-success status border-none",
        },
        {
          title: "بررسی شده",
          id: 5,
          status: "checked",
          active: false,
          style: "badge badge-info status border-none",
        },
        {
          title: "برگشت داده شده",
          id: 6,
          status: "returned",
          active: false,
          style: "badge badge-danger status border-none",
        },
      ],
      filterActive: "all",
      loader: false,
      counter: 1,
      intervalSeller: null,
    };
  },
  watch: {
    per_page() {
      this.changePage(1);
    },
  },
  computed: {
    interactionEnabled() {
      return this.$store.getters["admin/getInteractionEnabled"];
    },
  },

  mounted() {
    if (this.$route.query.status) {
      this.filterActive = this.$route.query.status;
    }
    this.loadData();
    this.intervalSeller = setInterval(() => {
      this.loadData("intervalSeller");

      // this.$refs.voice.play();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.intervalSeller);
  },
  methods: {
    enableSoundPlayback() {
      this.$store.commit("admin/setInteractionEnabled", true);
    },
    filterStatus(filter) {
      this.filterActive = filter.status;
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, status: filter.status },
      });
      this.filterBtns.forEach((item) => {
        if (item.status == filter.status) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.loadData();
    },
    async requestProduct() {
      try {
        this.disabled = true;
        let fd = new FormData();
        fd.append(`barcodes[0]`, this.productSku);
        const response = await this.$axios.post(
          "admin/change-status-seller-requests-to-complete",
          fd,
        );
        this.$root.notify(response.data.message, "success");
        // window.location.reload();
        this.loadData();
        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    numberListItem(list) {
      if (list && list.length) {
        let items = list.filter((item) => item.status == "pending");
        return items.length;
      } else {
        return "0";
      }
    },
    async loadData(typeRequest) {
      try {
        this.disabled = true;
        if (typeRequest != "intervalSeller") {
          this.loader = true;
        }

        let params = {
          page: this.page,
          per_page: this.per_page,
        };
        if (this.filterActive != null && this.filterActive != "all") {
          params.status =
            this.filterActive != null && this.filterActive != "all"
              ? this.filterActive
              : "";
        }
        const response = await this.$axios.get(`admin/requests-list-special`, {
          params: params,
        });
        this.$nextTick(() => {
          const input = this.$refs.productSku?.$el || this.$refs.productSku;
          input?.focus();
        });
        // this.seller = response.data.data.seller;
        this.sellerRequests = response.data.data.requests;
        const lastRequestِDate = new Date(
          response.data.data.last_request.created_at,
        );
        const nowDate = new Date(response.data.data.now);

        // اختلاف به ثانیه
        const diffInSeconds = (nowDate - lastRequestِDate) / 1000;

        if (diffInSeconds <= 10) {
          this.$refs.voice.play();
        } else {
          this.$refs.voice.pause();
        }
        console.log(diffInSeconds, "diffInSeconds");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.loader = false;
        this.$nextTick(() => {
          const input = this.$refs.productSku?.$el || this.$refs.productSku;
          input?.focus();
        });
      }
    },
  },
  watch: {
    disabled(val) {
      if (!val) {
        this.$nextTick(() => {
          const input = this.$refs.productSku?.$el || this.$refs.productSku;
          input?.focus();
        });
      }
    },
  },
};
